const normalize = value => String(value || "").toLocaleLowerCase("de").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ß/g, "ss");
export const sortedDriverBuses = buses => [...buses].sort((a, b) => String(a.name || `Bus ${a.id}`).localeCompare(String(b.name || `Bus ${b.id}`), "de", { numeric: true }));
export function driverMatchesSearch(driver, buses, query) {
  const terms = normalize(query).split(/\s+/).filter(Boolean);
  const assigned = buses.filter(bus => driver.busIds.includes(bus.id));
  const text = normalize([driver.name, driver.email, ...assigned.flatMap(bus => [bus.name, ...(bus.searchTerms || [])])].join(" "));
  return terms.every(term => text.includes(term));
}
